import React, { KeyboardEvent, useState, useEffect } from "react";
import IAutocompleteProps from "../types/autocomplete";
import styles from "./styles.module.scss";
import { InputFieldVW } from "./../index";
import { Menu } from ".././../menus/default";
import IItem from "./../../../interfaces/IItem";
import { IInputProps } from "../types";

const downKey = 40;
const upKey = 38;
const enterKey = 13;

export const AutocompleteTextInput = ({
  items,
  onItemClick,
  hintNumber = 5,
  value,
  applyIncludesAlgorithm,
  iconClick,
  ...rest
}: IInputProps & IAutocompleteProps) => {
  const [focusIndex, setfocusIndex] = useState<number | undefined>(undefined);
  const [openMenu, setOpenMenu] = useState<boolean>(true);

  useEffect(() => {
    setOpenMenu(true);
  }, [value]);

  let applicableItems = items
    .filter((item: IItem) =>
      item.label.toLowerCase().startsWith(value.toLowerCase())
    )
    .slice(0, hintNumber);
  const remainingItemsLen = hintNumber - applicableItems.length;
  if (remainingItemsLen > 0 && applyIncludesAlgorithm) {
    const includesItems = items
      .filter(
        (item: IItem) =>
          item.label.toLowerCase().includes(value.toLowerCase()) &&
          !applicableItems.find(
            (applicalbeItem: IItem) => applicalbeItem.value === item.value
          )
      )
      .slice(0, remainingItemsLen);
    applicableItems = applicableItems.concat(includesItems);
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (event.keyCode === downKey || event.charCode === downKey) {
      if (focusIndex === undefined) setfocusIndex(0);
      else setfocusIndex((focusIndex + 1) % hintNumber);
    }
    if (event.keyCode === upKey || event.charCode === upKey) {
      if (focusIndex === undefined || focusIndex === 0)
        setfocusIndex(hintNumber - 1);
      else setfocusIndex((focusIndex - 1) % hintNumber);
    }
    if (event.keyCode === enterKey || event.charCode === enterKey) {
      focusIndex && onItemClick(applicableItems[focusIndex]);
      setOpenMenu(false);
      event.preventDefault();
    }
  }
  function handleIconClick() {
    setOpenMenu(false);
    iconClick && iconClick();
  }
  function handleItemClick(item: IItem) {
    onItemClick(item);
    setOpenMenu(false);
  }
  return (
    <div className={styles.root}>
      <InputFieldVW
        {...rest}
        iconClick={handleIconClick}
        value={value}
        onKeyDown={handleKeyDown}
      />
      {value &&
        openMenu &&
        applicableItems.length > 0 &&
        value !== applicableItems[0].label && (
          <Menu
            items={applicableItems}
            focusIndex={focusIndex}
            onItemClick={handleItemClick}
            stateless={true}
          />
        )}
    </div>
  );
};
